import { Paper, PaperProps, styled } from "@mui/material";
import { breakpointValues, customBreakpoints } from "../../../styles/breakpoints";
import { pxToRem } from "../../../utils/fontSizeUtility";

export const WelcomeSectionPaper = styled(Paper)(({ theme }) => ({
  display: "none",
  [customBreakpoints.up(breakpointValues.md)]: {
    borderBottom: "1px solid",
    borderBottomColor: theme.palette.divider,
    color: theme.palette.grey["900"],
    display: "flex",
    flex: "none",
    flexDirection: "column",
    height: pxToRem(62),
    justifyContent: "flex-end",
    paddingBottom: pxToRem(20),
    position: "relative",
    zIndex: "11",
  },
})) as React.ComponentType<PaperProps>;
